<template>
  <nav class="site-navigation col-span-3 row-span-2 row-start-1">
    <router-link :tag="a"
                 class="site-branding"
                 to="/getting-started/installation"
    >
      <logo />
      Style Guide
    </router-link>
    <ul class="site-menu site-menu--top">
      <li :class="[currentPage.includes('getting-started') ? isActive: '',
                   'site-menu__item site-menu__item--top']"
      >
        <router-link :tag="a"
                     class="site-menu__link site-menu__link--top"
                     to="/getting-started/installation"
        >
          Getting started
        </router-link>
        <nav class="site-menu__sub">
          <ul class="site-menu site-menu--sub">
            <li class="site-menu__item site-menu__item--sub">
              <router-link :tag="a"
                           class="site-menu__link site-menu__link--sub"
                           to="/getting-started/installation"
              >
                Installation
              </router-link>
            </li>
            <li class="site-menu__item site-menu__item--sub">
              <router-link :tag="a"
                           class="site-menu__link site-menu__link--sub"
                           to="/getting-started/structure"
              >
                Structure
              </router-link>
            </li>
          </ul>
        </nav>
      </li>
      <li :class="[currentPage.includes('customisation') ? isActive: '',
                   'site-menu__item site-menu__item--top']"
      >
        <router-link :tag="a"
                     class="site-menu__link site-menu__link--top"
                     to="/customisation/configuration"
        >
          Customisation
        </router-link>
        <nav class="site-menu__sub">
          <ul class="site-menu site-menu--sub">
            <li class="site-menu__item site-menu__item--sub">
              <router-link :tag="a"
                           class="site-menu__link site-menu__link--sub"
                           to="/customisation/configuration"
              >
                Configuration
              </router-link>
            </li>
          </ul>
        </nav>
      </li>
      <li :class="[currentPage.includes('utilities') ? isActive: '',
                   'site-menu__item site-menu__item--top']"
      >
        <router-link :tag="a"
                     class="site-menu__link site-menu__link--top"
                     to="/utilities/background/attachment"
        >
          Utilities
        </router-link>
        <nav class="site-menu__sub">
          <ul class="site-menu site-menu--sub">
            <li class="site-menu__item site-menu__item--header">
              <span class="site-menu__link site-menu__link--title">Background</span>
            </li>
            <li :class="[currentPage.includes('utilities') ? isActive: '',
                         'site-menu__item site-menu__item--header']"
            >
              <router-link :tag="a"
                           class="site-menu__link site-menu__link--sub"
                           to="/utilities/background/attachment"
              >
                Attachment
              </router-link>
            </li>
            <li :class="[currentPage.includes('utilities') ? isActive: '',
                         'site-menu__item site-menu__item--header']"
            >
              <router-link :tag="a"
                           class="site-menu__link site-menu__link--sub"
                           to="/utilities/background/color"
              >
                Color
              </router-link>
            </li>
            <li :class="[currentPage.includes('utilities') ? isActive: '',
                         'site-menu__item site-menu__item--header']"
            >
              <router-link :tag="a"
                           class="site-menu__link site-menu__link--sub"
                           to="/utilities/background/position"
              >
                Position
              </router-link>
            </li>
            <li :class="[currentPage.includes('utilities') ? isActive: '',
                         'site-menu__item site-menu__item--header']"
            >
              <router-link :tag="a"
                           class="site-menu__link site-menu__link--sub"
                           to="/utilities/background/repeat"
              >
                Repeat
              </router-link>
            </li>
            <li :class="[currentPage.includes('utilities') ? isActive: '',
                         'site-menu__item site-menu__item--header']"
            >
              <router-link :tag="a"
                           class="site-menu__link site-menu__link--sub"
                           to="/utilities/background/size"
              >
                Size
              </router-link>
            </li>
          </ul>
        </nav>
        <nav class="site-menu__sub">
          <ul class="site-menu site-menu--sub">
            <li class="site-menu__item site-menu__item--header">
              <span class="site-menu__link site-menu__link--title">Border</span>
            </li>
            <li :class="[currentPage.includes('utilities') ? isActive: '',
                         'site-menu__item site-menu__item--header']"
            >
              <router-link :tag="a"
                           class="site-menu__link site-menu__link--sub"
                           to="/utilities/border/color"
              >
                Color
              </router-link>
            </li>
            <li :class="[currentPage.includes('utilities') ? isActive: '',
                         'site-menu__item site-menu__item--header']"
            >
              <router-link :tag="a"
                           class="site-menu__link site-menu__link--sub"
                           to="/utilities/border/radius"
              >
                Radius
              </router-link>
            </li>
            <li :class="[currentPage.includes('utilities') ? isActive: '',
                         'site-menu__item site-menu__item--header']"
            >
              <router-link :tag="a"
                           class="site-menu__link site-menu__link--sub"
                           to="/utilities/border/style"
              >
                Style
              </router-link>
            </li>
            <li :class="[currentPage.includes('utilities') ? isActive: '',
                         'site-menu__item site-menu__item--header']"
            >
              <router-link :tag="a"
                           class="site-menu__link site-menu__link--sub"
                           to="/utilities/border/width"
              >
                Width
              </router-link>
            </li>
          </ul>
        </nav>
        <nav class="site-menu__sub">
          <ul class="site-menu site-menu--sub">
            <li class="site-menu__item site-menu__item--header">
              <span class="site-menu__link site-menu__link--title">Flex/Grid alignment</span>
            </li>
            <li :class="[currentPage.includes('utilities') ? isActive: '',
                         'site-menu__item site-menu__item--header']"
            >
              <router-link :tag="a"
                           class="site-menu__link site-menu__link--sub"
                           to="/utilities/alignment/justify-content"
              >
                Justify content
              </router-link>
            </li>
            <li :class="[currentPage.includes('utilities') ? isActive: '',
                         'site-menu__item site-menu__item--header']"
            >
              <router-link :tag="a"
                           class="site-menu__link site-menu__link--sub"
                           to="/utilities/alignment/justify-items"
              >
                Justify items
              </router-link>
            </li>
            <li :class="[currentPage.includes('utilities') ? isActive: '',
                         'site-menu__item site-menu__item--header']"
            >
              <router-link :tag="a"
                           class="site-menu__link site-menu__link--sub"
                           to="/utilities/alignment/justify-self"
              >
                Justify self
              </router-link>
            </li>
          </ul>
        </nav>
        <nav class="site-menu__sub">
          <ul class="site-menu site-menu--sub">
            <li class="site-menu__item site-menu__item--header">
              <span class="site-menu__link site-menu__link--title">Flex</span>
            </li>
            <li :class="[currentPage.includes('flex') ? isActive: '',
                         'site-menu__item site-menu__item--header']"
            >
              <router-link :tag="a"
                           class="site-menu__link site-menu__link--sub"
                           to="/utilities/flex/direction"
              >
                Direction
              </router-link>
            </li>
            <li :class="[currentPage.includes('flex') ? isActive: '',
                         'site-menu__item site-menu__item--header']"
            >
              <router-link :tag="a"
                           class="site-menu__link site-menu__link--sub"
                           to="/utilities/flex/grow"
              >
                Grow
              </router-link>
            </li>
            <li :class="[currentPage.includes('flex') ? isActive: '',
                         'site-menu__item site-menu__item--header']"
            >
              <router-link :tag="a"
                           class="site-menu__link site-menu__link--sub"
                           to="/utilities/flex/order"
              >
                Order
              </router-link>
            </li>
            <li :class="[currentPage.includes('flex') ? isActive: '',
                         'site-menu__item site-menu__item--header']"
            >
              <router-link :tag="a"
                           class="site-menu__link site-menu__link--sub"
                           to="/utilities/flex/shrink"
              >
                Shrink
              </router-link>
            </li>
            <li :class="[currentPage.includes('flex') ? isActive: '',
                         'site-menu__item site-menu__item--header']"
            >
              <router-link :tag="a"
                           class="site-menu__link site-menu__link--sub"
                           to="/utilities/flex/wrap"
              >
                Wrap
              </router-link>
            </li>
          </ul>
        </nav>
        <nav class="site-menu__sub">
          <ul class="site-menu site-menu--sub">
            <li class="site-menu__item site-menu__item--header">
              <span class="site-menu__link site-menu__link--title">Grid</span>
            </li>
            <li :class="[currentPage.includes('utilities') ? isActive: '',
                         'site-menu__item site-menu__item--header']"
            >
              <router-link :tag="a"
                           class="site-menu__link site-menu__link--sub"
                           to="/utilities/grid/columns"
              >
                Columns
              </router-link>
            </li>
            <li :class="[currentPage.includes('utilities') ? isActive: '',
                         'site-menu__item site-menu__item--header']"
            >
              <router-link :tag="a"
                           class="site-menu__link site-menu__link--sub"
                           to="/utilities/grid/rows"
              >
                Rows
              </router-link>
            </li>
            <li :class="[currentPage.includes('utilities') ? isActive: '',
                         'site-menu__item site-menu__item--header']"
            >
              <router-link :tag="a"
                           class="site-menu__link site-menu__link--sub"
                           to="/utilities/grid/flow"
              >
                Flow
              </router-link>
            </li>
            <li :class="[currentPage.includes('utilities') ? isActive: '',
                         'site-menu__item site-menu__item--header']"
            >
              <router-link :tag="a"
                           class="site-menu__link site-menu__link--sub"
                           to="/utilities/grid/gap"
              >
                Gap
              </router-link>
            </li>
            <li :class="[currentPage.includes('utilities') ? isActive: '',
                         'site-menu__item site-menu__item--header']"
            >
              <router-link :tag="a"
                           class="site-menu__link site-menu__link--sub"
                           to="/utilities/grid/template-columns"
              >
                Template columns
              </router-link>
            </li>
            <li :class="[currentPage.includes('utilities') ? isActive: '',
                         'site-menu__item site-menu__item--header']"
            >
              <router-link :tag="a"
                           class="site-menu__link site-menu__link--sub"
                           to="/utilities/grid/template-rows"
              >
                Template rows
              </router-link>
            </li>
          </ul>
        </nav>
        <nav class="site-menu__sub">
          <ul class="site-menu site-menu--sub">
            <li class="site-menu__item site-menu__item--header">
              <span class="site-menu__link site-menu__link--title">Interactions</span>
            </li>
            <li :class="[currentPage.includes('utilities') ? isActive: '',
                         'site-menu__item site-menu__item--header']"
            >
              <router-link :tag="a"
                           class="site-menu__link site-menu__link--sub"
                           to="/utilities/interactions/cursor"
              >
                Cursor
              </router-link>
            </li>
            <li :class="[currentPage.includes('utilities') ? isActive: '',
                         'site-menu__item site-menu__item--header']"
            >
              <router-link :tag="a"
                           class="site-menu__link site-menu__link--sub"
                           to="/utilities/interactions/pointer-events"
              >
                Pointer events
              </router-link>
            </li>
            <li :class="[currentPage.includes('utilities') ? isActive: '',
                         'site-menu__item site-menu__item--header']"
            >
              <router-link :tag="a"
                           class="site-menu__link site-menu__link--sub"
                           to="/utilities/interactions/resize"
              >
                Resize
              </router-link>
            </li>
          </ul>
        </nav>
      </li>
    </ul>
  </nav>
</template>

<script>
import Logo from '@/components/svgs/Logo';

export default {
  components: {
    Logo,
  },
  data() {
    return {
      isActive: 'site-menu__item--visible',
    };
  },
  computed: {
    currentPage() {
      return this.$route.path;
    },
  },
};
</script>
